// Stacks one or more draft providers around a component.
// `providers` is `[{ Provider, ...providerProps }]` — outer first, inner last.
export function withDraftProviders(Component, providers) {
  function WithDraftProviders(props) {
    return providers.reduceRight(
      (children, { Provider, ...providerProps }) => (
        <Provider {...providerProps}>{children}</Provider>
      ),
      <Component {...props} />
    )
  }

  WithDraftProviders.displayName = `withDraftProviders(${
    Component.displayName ?? Component.name ?? 'Component'
  })`

  return WithDraftProviders
}
